import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class CustomerDeliverySitesResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: [{
                'delivery_site': {
                    'name': 'Stamford',
                    'location': {
                        'address': '333 Ludlow St',
                        'city': 'Stamford',
                        'postal_code': '',
                        'latitude': null,
                        'longitude': null,
                    },
                    'code': '001',
                    'customer': {
                        'code': '2345',
                        'fantasy_name': 'David',
                        'business_name': 'Sabre Corporation',
                        'taxpayer_identification_number': '334456338'
                    }
                }
            }],
            errors: []
        }
    }

    deliverySites() {
        return this.content().map(rawDeliverySite => ({
            name: rawDeliverySite.name,
            address: rawDeliverySite.location.address,
            city: rawDeliverySite.location.city,
            postalCode: rawDeliverySite.location.postal_code,
            latitude: rawDeliverySite.location.latitude,
            longitude: rawDeliverySite.location.longitude,
            code: rawDeliverySite.code
        }))
    }

    customer() {
        const customer = this.content()[0].customer
        return {
            code: customer.code,
            fantasyName: customer.fantasy_name,
            businessName: customer.business_name,
            taxpayerIdentificationNumber: customer.taxpayer_identification_number
        };
    }
}